
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppSelect, AppCard, AppButton } from '@/components';
import { useChallengeTranslate } from '@/modules/challenge/model/translate';
import { ROUTE_NAME_CHALLENGE } from '@/modules/challenge/router';

export default defineComponent({
    name: ROUTE_NAME_CHALLENGE.TRANSLATE,
    components: { AppFormRow, AppInput, AppSelect, AppCard, AppButton },
    setup() {
        const { model, v$, fetch, beforeFetch, actions, localeSupportedOptions } = useChallengeTranslate();

        onMounted(async () => {
            await beforeFetch();
            await fetch();
        });

        return { v$, model, fetch, actions, localeSupportedOptions };
    }
});
